/* eslint-disable */
// pyra is weird: 
// first 11 values are back row
// next 9 are the row that's closer
// and so on...

function applyMove(state, move) {
  new_state = state.slice();
  for (key of Object.keys(move)) {
    new_state[move[key]] = state[key];
  }
  return new_state;
}

function skewbScrambleToSVG(scramble_string) {
  state = new Array(30).fill(1);
  state.fill(2, 5, 10); 
  state.fill(3, 10, 15); 
  state.fill(4, 15, 20);
  state.fill(5, 20, 25);
  state.fill(6, 25);

  state_update = {
    "U": {
      0: 5, 5: 21, 21: 0,
      1: 6, 6: 24, 24: 1,
      16: 10, 10: 28, 28: 16,
      2: 7, 7: 22, 22: 2,
      3: 8, 8: 20, 20: 3,
    },
    "L": {
      3: 18, 18: 24, 24: 3,
      6: 14, 14: 28, 28: 6,
      10: 26, 26: 8, 8: 10,
      12: 27, 27: 7, 7: 12,
      9: 13, 13: 25, 25: 9,
    },
    "R": {
      14: 1, 1: 8, 8: 14,
      18: 20, 20: 28, 28: 18,
      26: 16, 16: 24, 24: 26,
      17: 22, 22: 27, 27: 17,
      19: 23, 23: 29, 29: 19,
    },
    "B": {
      0: 13, 13: 19, 19: 0,
      5: 25, 25: 23, 23: 5,
      21: 9, 9: 29, 29: 21,
      7: 27, 27: 22, 22: 7,
      8: 28, 28: 24, 24: 8,
    },
  };

  moves = scramble_string.split(" ");
  for (move of moves) {
    if (move.length > 1) {
      state = applyMove(state, state_update[move[0]]);
      state = applyMove(state, state_update[move[0]]);
    } else {
      state = applyMove(state, state_update[move]);
    }
  }

  return state;
}

function skewb_image(scramble=[1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 3, 3, 3, 3, 3, 4, 4, 4, 4, 4, 5, 5, 5, 5, 5, 6, 6, 6, 6, 6]) {
  var colors = ["black", "white", "orange", "green", "red", "blue", "yellow"];
  var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  var svgNS = svg.namespaceURI;
  svg.setAttribute('width', 550);
  svg.setAttribute('height', 350);

  var U = document.createElementNS(svgNS,'polygon');
  U.setAttribute('points', '150,0 200,50 150,100 100,50')
  U.setAttribute('stroke', 'black');
  U.setAttribute('fill', colors[scramble[2]]);
  svg.appendChild(U);
  var a = document.createElementNS(svgNS,'polygon');
  a.setAttribute('points', '100,0 150,0 100,50')
  a.setAttribute('stroke', 'black');
  a.setAttribute('fill', colors[scramble[0]]);
  svg.appendChild(a);
  var b = document.createElementNS(svgNS,'polygon');
  b.setAttribute('points', '150,0 200,0 200,50')
  b.setAttribute('stroke', 'black');
  b.setAttribute('fill', colors[scramble[1]]);
  svg.appendChild(b);
  var c = document.createElementNS(svgNS,'polygon');
  c.setAttribute('points', '100,50 150,100 100,100')
  c.setAttribute('stroke', 'black');
  c.setAttribute('fill', colors[scramble[3]]);
  svg.appendChild(c);
  var d = document.createElementNS(svgNS,'polygon');
  d.setAttribute('points', '200,50 200,100 150,100')
  d.setAttribute('stroke', 'black');
  d.setAttribute('fill', colors[scramble[4]]);
  svg.appendChild(d);

  var L = document.createElementNS(svgNS,'polygon');
  L.setAttribute('points', '50,100 100,150 50,200 0,150')
  L.setAttribute('stroke', 'black');
  L.setAttribute('fill', colors[scramble[7]]);
  svg.appendChild(L);
  var e = document.createElementNS(svgNS,'polygon');
  e.setAttribute('points', '0,100 50,100 0,150')
  e.setAttribute('stroke', 'black');
  e.setAttribute('fill', colors[scramble[5]]);
  svg.appendChild(e);
  var f = document.createElementNS(svgNS,'polygon');
  f.setAttribute('points', '50,100 100,100 100,150')
  f.setAttribute('stroke', 'black');
  f.setAttribute('fill', colors[scramble[6]]);
  svg.appendChild(f);
  var g = document.createElementNS(svgNS,'polygon');
  g.setAttribute('points', '0,150 50,200 0,200')
  g.setAttribute('stroke', 'black');
  g.setAttribute('fill', colors[scramble[8]]);
  svg.appendChild(g);
  var h = document.createElementNS(svgNS,'polygon');
  h.setAttribute('points', '100,150 100,200 50,200')
  h.setAttribute('stroke', 'black');
  h.setAttribute('fill', colors[scramble[9]]);
  svg.appendChild(h);

  var F = document.createElementNS(svgNS,'polygon');
  F.setAttribute('points', '150,100 200,150 150,200 100,150')
  F.setAttribute('stroke', 'black');
  F.setAttribute('fill', colors[scramble[12]]);
  svg.appendChild(F);
  var i = document.createElementNS(svgNS,'polygon');
  i.setAttribute('points', '100,100 150,100 100,150')
  i.setAttribute('stroke', 'black');
  i.setAttribute('fill', colors[scramble[10]]);
  svg.appendChild(i);
  var j = document.createElementNS(svgNS,'polygon');
  j.setAttribute('points', '150,100 200,100 200,150')
  j.setAttribute('stroke', 'black');
  j.setAttribute('fill', colors[scramble[11]]);
  svg.appendChild(j);
  var k = document.createElementNS(svgNS,'polygon');
  k.setAttribute('points', '100,150 150,200 100,200')
  k.setAttribute('stroke', 'black');
  k.setAttribute('fill', colors[scramble[13]]);
  svg.appendChild(k);
  var l = document.createElementNS(svgNS,'polygon');
  l.setAttribute('points', '200,150 200,200 150,200')
  l.setAttribute('stroke', 'black');
  l.setAttribute('fill', colors[scramble[14]]);
  svg.appendChild(l);

  var R = document.createElementNS(svgNS,'polygon');
  R.setAttribute('points', '250,100 300,150 250,200 200,150')
  R.setAttribute('stroke', 'black');
  R.setAttribute('fill', colors[scramble[17]]);
  svg.appendChild(R);
  var m = document.createElementNS(svgNS,'polygon');
  m.setAttribute('points', '200,100 250,100 200,150')
  m.setAttribute('stroke', 'black');
  m.setAttribute('fill', colors[scramble[15]]);
  svg.appendChild(m);
  var n = document.createElementNS(svgNS,'polygon');
  n.setAttribute('points', '250,100 300,100 300,150')
  n.setAttribute('stroke', 'black');
  n.setAttribute('fill', colors[scramble[16]]);
  svg.appendChild(n);
  var o = document.createElementNS(svgNS,'polygon');
  o.setAttribute('points', '200,150 250,200 200,200')
  o.setAttribute('stroke', 'black');
  o.setAttribute('fill', colors[scramble[18]]);
  svg.appendChild(o);
  var p = document.createElementNS(svgNS,'polygon');
  p.setAttribute('points', '300,150 300,200 250,200')
  p.setAttribute('stroke', 'black');
  p.setAttribute('fill', colors[scramble[19]]);
  svg.appendChild(p);

  var B = document.createElementNS(svgNS,'polygon');
  B.setAttribute('points', '350,100 400,150 350,200 300,150')
  B.setAttribute('stroke', 'black');
  B.setAttribute('fill', colors[scramble[22]]);
  svg.appendChild(B);
  var q = document.createElementNS(svgNS,'polygon');
  q.setAttribute('points', '300,100 350,100 300,150')
  q.setAttribute('stroke', 'black');
  q.setAttribute('fill', colors[scramble[20]]);
  svg.appendChild(q);
  var r = document.createElementNS(svgNS,'polygon');
  r.setAttribute('points', '350,100 400,100 400,150')
  r.setAttribute('stroke', 'black');
  r.setAttribute('fill', colors[scramble[21]]);
  svg.appendChild(r);
  var s = document.createElementNS(svgNS,'polygon');
  s.setAttribute('points', '300,150 350,200 300,200')
  s.setAttribute('stroke', 'black');
  s.setAttribute('fill', colors[scramble[23]]);
  svg.appendChild(s);
  var t = document.createElementNS(svgNS,'polygon');
  t.setAttribute('points', '400,150 400,200 350,200')
  t.setAttribute('stroke', 'black');
  t.setAttribute('fill', colors[scramble[24]]);
  svg.appendChild(t);

  var D = document.createElementNS(svgNS,'polygon');
  D.setAttribute('points', '150,200 200,250 150,300 100,250')
  D.setAttribute('stroke', 'black');
  D.setAttribute('fill', colors[scramble[27]]);
  svg.appendChild(D);
  var u = document.createElementNS(svgNS,'polygon');
  u.setAttribute('points', '100,200 150,200 100,250')
  u.setAttribute('stroke', 'black');
  u.setAttribute('fill', colors[scramble[25]]);
  svg.appendChild(u);
  var v = document.createElementNS(svgNS,'polygon');
  v.setAttribute('points', '150,200 200,200 200,250')
  v.setAttribute('stroke', 'black');
  v.setAttribute('fill', colors[scramble[26]]);
  svg.appendChild(v);
  var w = document.createElementNS(svgNS,'polygon');
  w.setAttribute('points', '100,250 150,300 100,300')
  w.setAttribute('stroke', 'black');
  w.setAttribute('fill', colors[scramble[28]]);
  svg.appendChild(w);
  var x = document.createElementNS(svgNS,'polygon');
  x.setAttribute('points', '200,250 200,300 150,300')
  x.setAttribute('stroke', 'black');
  x.setAttribute('fill', colors[scramble[29]]);
  svg.appendChild(x);

  return svg;
}

function fourScrambleToSVG(scramble_string) {
  
  state = new Array(96).fill(1);
  state.fill(2, 16, 32);
  state.fill(3, 32, 48);
  state.fill(4, 48, 64);
  state.fill(5, 64, 80);
  state.fill(6, 80, 96);

  state_update = {
    "U": {
      0: 3, 3: 15, 15: 12, 12: 0, 
      1: 7, 7: 14, 14: 8, 8: 1,
      2: 11, 11: 13, 13: 4, 4: 2, 
      5: 6, 6: 10, 10: 9, 9: 5,
      16: 64, 64: 48, 48: 32, 32: 16,
      17: 65, 65: 49, 49: 33, 33: 17,
      18: 66, 66: 50, 50: 34, 34: 18,
      19: 67, 67: 51, 51: 35, 35: 19,
    },
    "F": {
      32: 35, 35: 47, 47: 44, 44: 32, 
      33: 39, 39: 46, 46: 40, 40: 33,
      34: 43, 43: 45, 45: 36, 36: 34, 
      37: 38, 38: 42, 42: 41, 41: 37,
      12: 48, 48: 83, 83: 31, 31: 12,
      13: 52, 52: 82, 82: 27, 27: 13,
      14: 56, 56: 81, 81: 23, 23: 14,
      15: 60, 60: 80, 80: 19, 19: 15,
    },
    "L": {
      16: 19, 19: 31, 31: 28, 28: 16, 
      17: 23, 23: 30, 30: 24, 24: 17,
      18: 27, 27: 29, 29: 20, 20: 18, 
      21: 22, 22: 26, 26: 25, 25: 21,
      0: 32, 32: 80, 80: 79, 79: 0,
      4: 36, 36: 84, 84: 75, 75: 4,
      8: 40, 40: 88, 88: 71, 71: 8,
      12: 44, 44: 92, 92: 67, 67: 12,
    },
    "R": {
      48: 51, 51: 63, 63: 60, 60: 48, 
      49: 55, 55: 62, 62: 56, 56: 49,
      50: 59, 59: 61, 61: 52, 52: 50, 
      53: 54, 54: 58, 58: 57, 57: 53,
      3: 76, 76: 83, 83: 35, 35: 3,
      7: 72, 72: 87, 87: 39, 39: 7,
      11: 68, 68: 91, 91: 43, 43: 11,
      15: 64, 64: 95, 95: 47, 47: 15,
    },
    "D": {
      80: 83, 83: 95, 95: 92, 92: 80, 
      81: 87, 87: 94, 94: 88, 88: 81,
      82: 91, 91: 93, 93: 84, 84: 82, 
      85: 86, 86: 90, 90: 89, 89: 85,
      44: 60, 60: 76, 76: 28, 28: 44,
      45: 61, 61: 77, 77: 29, 29: 45,
      46: 62, 62: 78, 78: 30, 30: 46,
      47: 63, 63: 79, 79: 31, 31: 47,
    },
    "B": {
      64: 67, 67: 79, 79: 76, 76: 64, 
      65: 71, 71: 78, 78: 72, 72: 65,
      66: 75, 75: 77, 77: 68, 68: 66, 
      69: 70, 70: 74, 74: 73, 73: 69,
      0: 28, 28: 95, 95: 51, 51: 0,
      1: 24, 24: 94, 94: 55, 55: 1,
      2: 20, 20: 93, 93: 59, 59: 2,
      3: 16, 16: 92, 92: 63, 63: 3,
    },
  }

  wide_state_update = {
    "U": {
      0: 3, 3: 15, 15: 12, 12: 0, 
      1: 7, 7: 14, 14: 8, 8: 1,
      2: 11, 11: 13, 13: 4, 4: 2, 
      5: 6, 6: 10, 10: 9, 9: 5,
      16: 64, 64: 48, 48: 32, 32: 16,
      17: 65, 65: 49, 49: 33, 33: 17,
      18: 66, 66: 50, 50: 34, 34: 18,
      19: 67, 67: 51, 51: 35, 35: 19,
      20: 68, 68: 52, 52: 36, 36: 20,
      21: 69, 69: 53, 53: 37, 37: 21,
      22: 70, 70: 54, 54: 38, 38: 22,
      23: 71, 71: 55, 55: 39, 39: 23,
    },
    "F": {
      32: 35, 35: 47, 47: 44, 44: 32, 
      33: 39, 39: 46, 46: 40, 40: 33,
      34: 43, 43: 45, 45: 36, 36: 34, 
      37: 38, 38: 42, 42: 41, 41: 37,
      12: 48, 48: 83, 83: 31, 31: 12,
      13: 52, 52: 82, 82: 27, 27: 13,
      14: 56, 56: 81, 81: 23, 23: 14,
      15: 60, 60: 80, 80: 19, 19: 15,
      8: 49, 49: 87, 87: 30, 30: 8,
      9: 53, 53: 86, 86: 26, 26: 9,
      10: 57, 57: 85, 85: 22, 22: 10,
      11: 61, 61: 84, 84: 18, 18: 11,
    },
    "L": {
      16: 19, 19: 31, 31: 28, 28: 16, 
      17: 23, 23: 30, 30: 24, 24: 17,
      18: 27, 27: 29, 29: 20, 20: 18, 
      21: 22, 22: 26, 26: 25, 25: 21,
      0: 32, 32: 80, 80: 79, 79: 0,
      4: 36, 36: 84, 84: 75, 75: 4,
      8: 40, 40: 88, 88: 71, 71: 8,
      12: 44, 44: 92, 92: 67, 67: 12,
      1: 33, 33: 81, 81: 78, 78: 1,
      5: 37, 37: 85, 85: 74, 74: 5,
      9: 41, 41: 89, 89: 70, 70: 9,
      13: 45, 45: 93, 93: 66, 66: 13,
    },
    "R": {
      48: 51, 51: 63, 63: 60, 60: 48, 
      49: 55, 55: 62, 62: 56, 56: 49,
      50: 59, 59: 61, 61: 52, 52: 50, 
      53: 54, 54: 58, 58: 57, 57: 53,
      3: 76, 76: 83, 83: 35, 35: 3,
      7: 72, 72: 87, 87: 39, 39: 7,
      11: 68, 68: 91, 91: 43, 43: 11,
      15: 64, 64: 95, 95: 47, 47: 15,
      2: 77, 77: 82, 82: 34, 34: 2,
      6: 73, 73: 86, 86: 38, 38: 6,
      10: 69, 69: 90, 90: 42, 42: 10,
      14: 65, 65: 94, 94: 46, 46: 14, 
    },
    "D": {
      80: 83, 83: 95, 95: 92, 92: 80, 
      81: 87, 87: 94, 94: 88, 88: 81,
      82: 91, 91: 93, 93: 84, 84: 82, 
      85: 86, 86: 90, 90: 89, 89: 85,
      40: 56, 56: 72, 72: 24, 24: 40,
      41: 57, 57: 73, 73: 25, 25: 41,
      42: 58, 58: 74, 74: 26, 26: 42,
      43: 59, 59: 75, 75: 27, 27: 43,
      44: 60, 60: 76, 76: 28, 28: 44,
      45: 61, 61: 77, 77: 29, 29: 45,
      46: 62, 62: 78, 78: 30, 30: 46,
      47: 63, 63: 79, 79: 31, 31: 47,
    },
    "B": {
      64: 67, 67: 79, 79: 76, 76: 64, 
      65: 71, 71: 78, 78: 72, 72: 65,
      66: 75, 75: 77, 77: 68, 68: 66, 
      69: 70, 70: 74, 74: 73, 73: 69,
      0: 28, 28: 95, 95: 51, 51: 0,
      1: 24, 24: 94, 94: 55, 55: 1,
      2: 20, 20: 93, 93: 59, 59: 2,
      3: 16, 16: 92, 92: 63, 63: 3,
      4: 29, 29: 91, 91: 50, 50: 4,
      5: 25, 25: 90, 90: 54, 54: 5,
      6: 21, 21: 89, 89: 58, 58: 6,
      7: 17, 17: 88, 88: 62, 62: 7,
    },
  }

  moves = scramble_string.split(" ");
  for (move of moves) {
    if (move.includes("w")) {
      if (move.length > 2) {
        state = applyMove(state, wide_state_update[move[0]]);
        state = applyMove(state, wide_state_update[move[0]]);
        if (move[2] == "'") {
          state = applyMove(state, wide_state_update[move[0]]);
        }
      } else {
        state = applyMove(state, wide_state_update[move[0]]);
      }
    } else {
      if (move.length > 1) {
        state = applyMove(state, state_update[move[0]]);
        state = applyMove(state, state_update[move[0]]);
        if (move[1] == "'") {
          state = applyMove(state, state_update[move[0]]);
        }
      } else {
        state = applyMove(state, state_update[move]);
      }
    }
  }

  return state;
}

function image_4x4(scramble) {

  var colors = ["black", "white", "orange", "green", "red", "blue", "yellow"];
  var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  var svgNS = svg.namespaceURI;
  svg.setAttribute('width', 550);
  svg.setAttribute('height', 350);

  // U
  for (i = 0; i < 4; i ++) {
    for (j = 0; j < 4; j ++) {
      x = 102+25*j;
      y = 25*i;
      var sq = document.createElementNS(svgNS,'rect');
        sq.setAttribute('width', 25); sq.setAttribute('height', 25);
        sq.setAttribute('x', x); sq.setAttribute('y', y);
        sq.setAttribute('stroke', 'black');
        sq.setAttribute('fill', colors[scramble[i*4+j]]);
        svg.appendChild(sq);
    }
  }

  // L
  for (i = 0; i < 4; i ++) {
    for (j = 0; j < 4; j ++) {
      x = 25*j;
      y = 103+25*i;
      var sq = document.createElementNS(svgNS,'rect');
        sq.setAttribute('width', 25); sq.setAttribute('height', 25);
        sq.setAttribute('x', x); sq.setAttribute('y', y);
        sq.setAttribute('stroke', 'black');
        sq.setAttribute('fill', colors[scramble[i*4+j+16]]);
        svg.appendChild(sq);
    }
  }

  // F
  for (i = 0; i < 4; i ++) {
    for (j = 0; j < 4; j ++) {
      x = 103+25*j;
      y = 103+25*i;
      var sq = document.createElementNS(svgNS,'rect');
        sq.setAttribute('width', 25); sq.setAttribute('height', 25);
        sq.setAttribute('x', x); sq.setAttribute('y', y);
        sq.setAttribute('stroke', 'black');
        sq.setAttribute('fill', colors[scramble[i*4+j+32]]);
        svg.appendChild(sq);
    }
  }

  // R
  for (i = 0; i < 4; i ++) {
    for (j = 0; j < 4; j ++) {
      x = 206+25*j;
      y = 103+25*i;
      var sq = document.createElementNS(svgNS,'rect');
        sq.setAttribute('width', 25); sq.setAttribute('height', 25);
        sq.setAttribute('x', x); sq.setAttribute('y', y);
        sq.setAttribute('stroke', 'black');
        sq.setAttribute('fill', colors[scramble[i*4+j+48]]);
        svg.appendChild(sq);
    }
  }

  // B
  for (i = 0; i < 4; i ++) {
    for (j = 0; j < 4; j ++) {
      x = 309+25*j;
      y = 103+25*i;
      var sq = document.createElementNS(svgNS,'rect');
        sq.setAttribute('width', 25); sq.setAttribute('height', 25);
        sq.setAttribute('x', x); sq.setAttribute('y', y);
        sq.setAttribute('stroke', 'black');
        sq.setAttribute('fill', colors[scramble[i*4+j+64]]);
        svg.appendChild(sq);
    }
  }

  // D
  for (i = 0; i < 4; i ++) {
    for (j = 0; j < 4; j ++) {
      x = 103+25*j;
      y = 206+25*i;
      var sq = document.createElementNS(svgNS,'rect');
        sq.setAttribute('width', 25); sq.setAttribute('height', 25);
        sq.setAttribute('x', x); sq.setAttribute('y', y);
        sq.setAttribute('stroke', 'black');
        sq.setAttribute('fill', colors[scramble[i*4+j+80]]);
        svg.appendChild(sq);
    }
  }

  return svg;
}

function fiveScrambleToSVG(scramble_string) {
  
  state = new Array(150).fill(1);
  state.fill(2, 16, 32);
  state.fill(3, 32, 48);
  state.fill(4, 48, 64);
  state.fill(5, 64, 80);
  state.fill(6, 80, 96);
  state.fill(1, 96, 105);
  state.fill(2, 105, 114);
  state.fill(3, 114, 123);
  state.fill(4, 123, 132);
  state.fill(5, 132, 141);
  state.fill(6, 141, 150);

  state_update = {
    "U": {
      0: 3, 3: 15, 15: 12, 12: 0, 
      1: 7, 7: 14, 14: 8, 8: 1,
      2: 11, 11: 13, 13: 4, 4: 2, 
      5: 6, 6: 10, 10: 9, 9: 5,
      16: 64, 64: 48, 48: 32, 32: 16,
      17: 65, 65: 49, 49: 33, 33: 17,
      18: 66, 66: 50, 50: 34, 34: 18,
      19: 67, 67: 51, 51: 35, 35: 19,
      96: 102, 102: 104, 104: 98, 98: 96,
      97: 101, 101: 103, 103: 99, 99: 97,
      105: 132, 132: 123, 123: 114, 114: 105,
    },
    "F": {
      32: 35, 35: 47, 47: 44, 44: 32, 
      33: 39, 39: 46, 46: 40, 40: 33,
      34: 43, 43: 45, 45: 36, 36: 34, 
      37: 38, 38: 42, 42: 41, 41: 37,
      12: 48, 48: 83, 83: 31, 31: 12,
      13: 52, 52: 82, 82: 27, 27: 13,
      14: 56, 56: 81, 81: 23, 23: 14,
      15: 60, 60: 80, 80: 19, 19: 15,
      114: 120, 120: 122, 122: 116, 116: 114,
      115: 119, 119: 121, 121: 117, 117: 115,
      104: 125, 125: 141, 141: 111, 111: 104,
    },
    "L": {
      16: 19, 19: 31, 31: 28, 28: 16, 
      17: 23, 23: 30, 30: 24, 24: 17,
      18: 27, 27: 29, 29: 20, 20: 18, 
      21: 22, 22: 26, 26: 25, 25: 21,
      0: 32, 32: 80, 80: 79, 79: 0,
      4: 36, 36: 84, 84: 75, 75: 4,
      8: 40, 40: 88, 88: 71, 71: 8,
      12: 44, 44: 92, 92: 67, 67: 12,
      105: 111, 111: 113, 113: 107, 107: 105,
      106: 110, 110: 112, 112: 108, 108: 106,
      98: 116, 116: 143, 143: 138, 138: 98,
    },
    "R": {
      48: 51, 51: 63, 63: 60, 60: 48, 
      49: 55, 55: 62, 62: 56, 56: 49,
      50: 59, 59: 61, 61: 52, 52: 50, 
      53: 54, 54: 58, 58: 57, 57: 53,
      3: 76, 76: 83, 83: 35, 35: 3,
      7: 72, 72: 87, 87: 39, 39: 7,
      11: 68, 68: 91, 91: 43, 43: 11,
      15: 64, 64: 95, 95: 47, 47: 15,
      123: 129, 129: 131, 131: 125, 125: 123,
      124: 128, 128: 130, 130: 126, 126: 124,
      102: 134, 134: 147, 147: 120, 120: 102,
    },
    "D": {
      80: 83, 83: 95, 95: 92, 92: 80, 
      81: 87, 87: 94, 94: 88, 88: 81,
      82: 91, 91: 93, 93: 84, 84: 82, 
      85: 86, 86: 90, 90: 89, 89: 85,
      44: 60, 60: 76, 76: 28, 28: 44,
      45: 61, 61: 77, 77: 29, 29: 45,
      46: 62, 62: 78, 78: 30, 30: 46,
      47: 63, 63: 79, 79: 31, 31: 47,
      141: 147, 147: 149, 149: 143, 143: 141,
      142: 146, 146: 148, 148: 144, 144: 142,
      113: 122, 122: 131, 131: 140, 140: 113,
    },
    "B": {
      64: 67, 67: 79, 79: 76, 76: 64, 
      65: 71, 71: 78, 78: 72, 72: 65,
      66: 75, 75: 77, 77: 68, 68: 66, 
      69: 70, 70: 74, 74: 73, 73: 69,
      0: 28, 28: 95, 95: 51, 51: 0,
      1: 24, 24: 94, 94: 55, 55: 1,
      2: 20, 20: 93, 93: 59, 59: 2,
      3: 16, 16: 92, 92: 63, 63: 3,
      132: 138, 138: 140, 140: 134, 134: 132,
      133: 137, 137: 139, 139: 135, 135: 133,
      96: 107, 107: 149, 149: 129, 129: 96,
    },
  }

  wide_state_update = {
    "U": {
      0: 3, 3: 15, 15: 12, 12: 0, 
      1: 7, 7: 14, 14: 8, 8: 1,
      2: 11, 11: 13, 13: 4, 4: 2, 
      5: 6, 6: 10, 10: 9, 9: 5,
      16: 64, 64: 48, 48: 32, 32: 16,
      17: 65, 65: 49, 49: 33, 33: 17,
      18: 66, 66: 50, 50: 34, 34: 18,
      19: 67, 67: 51, 51: 35, 35: 19,
      20: 68, 68: 52, 52: 36, 36: 20,
      21: 69, 69: 53, 53: 37, 37: 21,
      22: 70, 70: 54, 54: 38, 38: 22,
      23: 71, 71: 55, 55: 39, 39: 23,
      96: 102, 102: 104, 104: 98, 98: 96,
      97: 101, 101: 103, 103: 99, 99: 97,
      105: 132, 132: 123, 123: 114, 114: 105,
      106: 133, 133: 124, 124: 115, 115: 106,
    },
    "F": {
      32: 35, 35: 47, 47: 44, 44: 32, 
      33: 39, 39: 46, 46: 40, 40: 33,
      34: 43, 43: 45, 45: 36, 36: 34, 
      37: 38, 38: 42, 42: 41, 41: 37,
      12: 48, 48: 83, 83: 31, 31: 12,
      13: 52, 52: 82, 82: 27, 27: 13,
      14: 56, 56: 81, 81: 23, 23: 14,
      15: 60, 60: 80, 80: 19, 19: 15,
      8: 49, 49: 87, 87: 30, 30: 8,
      9: 53, 53: 86, 86: 26, 26: 9,
      10: 57, 57: 85, 85: 22, 22: 10,
      11: 61, 61: 84, 84: 18, 18: 11,
      114: 120, 120: 122, 122: 116, 116: 114,
      115: 119, 119: 121, 121: 117, 117: 115,
      104: 125, 125: 141, 141: 111, 111: 104,
      103: 126, 126: 142, 142: 110, 110: 103,
    },
    "L": {
      16: 19, 19: 31, 31: 28, 28: 16, 
      17: 23, 23: 30, 30: 24, 24: 17,
      18: 27, 27: 29, 29: 20, 20: 18, 
      21: 22, 22: 26, 26: 25, 25: 21,
      0: 32, 32: 80, 80: 79, 79: 0,
      4: 36, 36: 84, 84: 75, 75: 4,
      8: 40, 40: 88, 88: 71, 71: 8,
      12: 44, 44: 92, 92: 67, 67: 12,
      1: 33, 33: 81, 81: 78, 78: 1,
      5: 37, 37: 85, 85: 74, 74: 5,
      9: 41, 41: 89, 89: 70, 70: 9,
      13: 45, 45: 93, 93: 66, 66: 13,
      105: 111, 111: 113, 113: 107, 107: 105,
      106: 110, 110: 112, 112: 108, 108: 106,
      98: 116, 116: 143, 143: 138, 138: 98,
      99: 117, 117: 144, 144: 137, 137: 99,
    },
    "R": {
      48: 51, 51: 63, 63: 60, 60: 48, 
      49: 55, 55: 62, 62: 56, 56: 49,
      50: 59, 59: 61, 61: 52, 52: 50, 
      53: 54, 54: 58, 58: 57, 57: 53,
      3: 76, 76: 83, 83: 35, 35: 3,
      7: 72, 72: 87, 87: 39, 39: 7,
      11: 68, 68: 91, 91: 43, 43: 11,
      15: 64, 64: 95, 95: 47, 47: 15,
      2: 77, 77: 82, 82: 34, 34: 2,
      6: 73, 73: 86, 86: 38, 38: 6,
      10: 69, 69: 90, 90: 42, 42: 10,
      14: 65, 65: 94, 94: 46, 46: 14, 
      123: 129, 129: 131, 131: 125, 125: 123,
      124: 128, 128: 130, 130: 126, 126: 124,
      102: 134, 134: 147, 147: 120, 120: 102,
      101: 135, 135: 146, 146: 119, 119: 101,
    },
    "D": {
      80: 83, 83: 95, 95: 92, 92: 80, 
      81: 87, 87: 94, 94: 88, 88: 81,
      82: 91, 91: 93, 93: 84, 84: 82, 
      85: 86, 86: 90, 90: 89, 89: 85,
      40: 56, 56: 72, 72: 24, 24: 40,
      41: 57, 57: 73, 73: 25, 25: 41,
      42: 58, 58: 74, 74: 26, 26: 42,
      43: 59, 59: 75, 75: 27, 27: 43,
      44: 60, 60: 76, 76: 28, 28: 44,
      45: 61, 61: 77, 77: 29, 29: 45,
      46: 62, 62: 78, 78: 30, 30: 46,
      47: 63, 63: 79, 79: 31, 31: 47,
      141: 147, 147: 149, 149: 143, 143: 141,
      142: 146, 146: 148, 148: 144, 144: 142,
      113: 122, 122: 131, 131: 140, 140: 113,
      112: 121, 121: 130, 130: 139, 139: 112,
    },
    "B": {
      64: 67, 67: 79, 79: 76, 76: 64, 
      65: 71, 71: 78, 78: 72, 72: 65,
      66: 75, 75: 77, 77: 68, 68: 66, 
      69: 70, 70: 74, 74: 73, 73: 69,
      0: 28, 28: 95, 95: 51, 51: 0,
      1: 24, 24: 94, 94: 55, 55: 1,
      2: 20, 20: 93, 93: 59, 59: 2,
      3: 16, 16: 92, 92: 63, 63: 3,
      4: 29, 29: 91, 91: 50, 50: 4,
      5: 25, 25: 90, 90: 54, 54: 5,
      6: 21, 21: 89, 89: 58, 58: 6,
      7: 17, 17: 88, 88: 62, 62: 7,
      132: 138, 138: 140, 140: 134, 134: 132,
      133: 137, 137: 139, 139: 135, 135: 133,
      96: 107, 107: 149, 149: 129, 129: 96,
      97: 108, 108: 148, 148: 128, 128: 97,
    },
  }

  moves = scramble_string.split(" ");
  for (move of moves) {
    if (move.includes("w")) {
      if (move.length > 2) {
        state = applyMove(state, wide_state_update[move[0]]);
        state = applyMove(state, wide_state_update[move[0]]);
        if (move[2] == "'") {
          state = applyMove(state, wide_state_update[move[0]]);
        }
      } else {
        state = applyMove(state, wide_state_update[move[0]]);
      }
    } else {
      if (move.length > 1) {
        state = applyMove(state, state_update[move[0]]);
        state = applyMove(state, state_update[move[0]]);
        if (move[1] == "'") {
          state = applyMove(state, state_update[move[0]]);
        }
      } else {
        state = applyMove(state, state_update[move]);
      }
    }
  }

  return state;
}

function image_5x5(scramble) {

  var colors = ["black", "white", "orange", "green", "red", "blue", "yellow"];
  var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  var svgNS = svg.namespaceURI;
  svg.setAttribute('width', 550);
  svg.setAttribute('height', 350);

  // U
  for (i = 0; i < 4; i ++) {
    for (j = 0; j < 4; j ++) {
      x = 103+20*(Math.floor(1.34*(j+1)-1));
      y = 20*(Math.floor(1.34*(i+1)-1));
      var sq = document.createElementNS(svgNS,'rect');
        sq.setAttribute('width', 20); sq.setAttribute('height', 20);
        sq.setAttribute('x', x); sq.setAttribute('y', y);
        sq.setAttribute('stroke', 'black');
        sq.setAttribute('fill', colors[scramble[i*4+j]]);
        svg.appendChild(sq);
    }
  }
  var sq = document.createElementNS(svgNS,'rect');
  sq.setAttribute('width', 20); sq.setAttribute('height', 20);
  sq.setAttribute('x', 143); sq.setAttribute('y', 0);
  sq.setAttribute('stroke', 'black');
  sq.setAttribute('fill', colors[scramble[96]]);
  svg.appendChild(sq);
  var sq = document.createElementNS(svgNS,'rect');
  sq.setAttribute('width', 20); sq.setAttribute('height', 20);
  sq.setAttribute('x', 143); sq.setAttribute('y', 20);
  sq.setAttribute('stroke', 'black');
  sq.setAttribute('fill', colors[scramble[97]]);
  svg.appendChild(sq);
  var sq = document.createElementNS(svgNS,'rect');
  sq.setAttribute('width', 20); sq.setAttribute('height', 20);
  sq.setAttribute('x', 143); sq.setAttribute('y', 60);
  sq.setAttribute('stroke', 'black');
  sq.setAttribute('fill', colors[scramble[103]]);
  svg.appendChild(sq);
  var sq = document.createElementNS(svgNS,'rect');
  sq.setAttribute('width', 20); sq.setAttribute('height', 20);
  sq.setAttribute('x', 143); sq.setAttribute('y', 80);
  sq.setAttribute('stroke', 'black');
  sq.setAttribute('fill', colors[scramble[104]]);
  svg.appendChild(sq);
  for (j = 0; j < 5; j ++) {
    x = 20*j+103;
    y = 40;
    var sq = document.createElementNS(svgNS,'rect');
      sq.setAttribute('width', 20); sq.setAttribute('height', 20);
      sq.setAttribute('x', x); sq.setAttribute('y', y);
      sq.setAttribute('stroke', 'black');
      sq.setAttribute('fill', colors[scramble[j+98]]);
      svg.appendChild(sq);
  }

  // L
  for (i = 0; i < 4; i ++) {
    for (j = 0; j < 4; j ++) {
      x = 20*(Math.floor(1.34*(j+1)-1));
      y = 103+20*(Math.floor(1.34*(i+1)-1));
      var sq = document.createElementNS(svgNS,'rect');
        sq.setAttribute('width', 20); sq.setAttribute('height', 20);
        sq.setAttribute('x', x); sq.setAttribute('y', y);
        sq.setAttribute('stroke', 'black');
        sq.setAttribute('fill', colors[scramble[i*4+j+16]]);
        svg.appendChild(sq);
    }
  }
  var sq = document.createElementNS(svgNS,'rect');
  sq.setAttribute('width', 20); sq.setAttribute('height', 20);
  sq.setAttribute('x', 40); sq.setAttribute('y', 103);
  sq.setAttribute('stroke', 'black');
  sq.setAttribute('fill', colors[scramble[105]]);
  svg.appendChild(sq);
  var sq = document.createElementNS(svgNS,'rect');
  sq.setAttribute('width', 20); sq.setAttribute('height', 20);
  sq.setAttribute('x', 40); sq.setAttribute('y', 123);
  sq.setAttribute('stroke', 'black');
  sq.setAttribute('fill', colors[scramble[106]]);
  svg.appendChild(sq);
  var sq = document.createElementNS(svgNS,'rect');
  sq.setAttribute('width', 20); sq.setAttribute('height', 20);
  sq.setAttribute('x', 40); sq.setAttribute('y', 163);
  sq.setAttribute('stroke', 'black');
  sq.setAttribute('fill', colors[scramble[112]]);
  svg.appendChild(sq);
  var sq = document.createElementNS(svgNS,'rect');
  sq.setAttribute('width', 20); sq.setAttribute('height', 20);
  sq.setAttribute('x', 40); sq.setAttribute('y', 183);
  sq.setAttribute('stroke', 'black');
  sq.setAttribute('fill', colors[scramble[113]]);
  svg.appendChild(sq);
  for (j = 0; j < 5; j ++) {
    x = 20*j;
    y = 143;
    var sq = document.createElementNS(svgNS,'rect');
      sq.setAttribute('width', 20); sq.setAttribute('height', 20);
      sq.setAttribute('x', x); sq.setAttribute('y', y);
      sq.setAttribute('stroke', 'black');
      sq.setAttribute('fill', colors[scramble[j+107]]);
      svg.appendChild(sq);
  }

  // F
  for (i = 0; i < 4; i ++) {
    for (j = 0; j < 4; j ++) {
      x = 103+20*(Math.floor(1.34*(j+1)-1));
      y = 103+20*(Math.floor(1.34*(i+1)-1));
      var sq = document.createElementNS(svgNS,'rect');
        sq.setAttribute('width', 20); sq.setAttribute('height', 20);
        sq.setAttribute('x', x); sq.setAttribute('y', y);
        sq.setAttribute('stroke', 'black');
        sq.setAttribute('fill', colors[scramble[i*4+j+32]]);
        svg.appendChild(sq);
    }
  }
  var sq = document.createElementNS(svgNS,'rect');
  sq.setAttribute('width', 20); sq.setAttribute('height', 20);
  sq.setAttribute('x', 143); sq.setAttribute('y', 103);
  sq.setAttribute('stroke', 'black');
  sq.setAttribute('fill', colors[scramble[114]]);
  svg.appendChild(sq);
  var sq = document.createElementNS(svgNS,'rect');
  sq.setAttribute('width', 20); sq.setAttribute('height', 20);
  sq.setAttribute('x', 143); sq.setAttribute('y', 123);
  sq.setAttribute('stroke', 'black');
  sq.setAttribute('fill', colors[scramble[115]]);
  svg.appendChild(sq);
  var sq = document.createElementNS(svgNS,'rect');
  sq.setAttribute('width', 20); sq.setAttribute('height', 20);
  sq.setAttribute('x', 143); sq.setAttribute('y', 163);
  sq.setAttribute('stroke', 'black');
  sq.setAttribute('fill', colors[scramble[121]]);
  svg.appendChild(sq);
  var sq = document.createElementNS(svgNS,'rect');
  sq.setAttribute('width', 20); sq.setAttribute('height', 20);
  sq.setAttribute('x', 143); sq.setAttribute('y', 183);
  sq.setAttribute('stroke', 'black');
  sq.setAttribute('fill', colors[scramble[122]]);
  svg.appendChild(sq);
  for (j = 0; j < 5; j ++) {
    x = 20*j+103;
    y = 143;
    var sq = document.createElementNS(svgNS,'rect');
      sq.setAttribute('width', 20); sq.setAttribute('height', 20);
      sq.setAttribute('x', x); sq.setAttribute('y', y);
      sq.setAttribute('stroke', 'black');
      sq.setAttribute('fill', colors[scramble[j+116]]);
      svg.appendChild(sq);
  }

  // R
  for (i = 0; i < 4; i ++) {
    for (j = 0; j < 4; j ++) {
      x = 205+20*(Math.floor(1.34*(j+1)-1));
      y = 103+20*(Math.floor(1.34*(i+1)-1));
      var sq = document.createElementNS(svgNS,'rect');
        sq.setAttribute('width', 20); sq.setAttribute('height', 20);
        sq.setAttribute('x', x); sq.setAttribute('y', y);
        sq.setAttribute('stroke', 'black');
        sq.setAttribute('fill', colors[scramble[i*4+j+48]]);
        svg.appendChild(sq);
    }
  }
  var sq = document.createElementNS(svgNS,'rect');
  sq.setAttribute('width', 20); sq.setAttribute('height', 20);
  sq.setAttribute('x', 245); sq.setAttribute('y', 103);
  sq.setAttribute('stroke', 'black');
  sq.setAttribute('fill', colors[scramble[123]]);
  svg.appendChild(sq);
  var sq = document.createElementNS(svgNS,'rect');
  sq.setAttribute('width', 20); sq.setAttribute('height', 20);
  sq.setAttribute('x', 245); sq.setAttribute('y', 123);
  sq.setAttribute('stroke', 'black');
  sq.setAttribute('fill', colors[scramble[124]]);
  svg.appendChild(sq);
  var sq = document.createElementNS(svgNS,'rect');
  sq.setAttribute('width', 20); sq.setAttribute('height', 20);
  sq.setAttribute('x', 245); sq.setAttribute('y', 163);
  sq.setAttribute('stroke', 'black');
  sq.setAttribute('fill', colors[scramble[130]]);
  svg.appendChild(sq);
  var sq = document.createElementNS(svgNS,'rect');
  sq.setAttribute('width', 20); sq.setAttribute('height', 20);
  sq.setAttribute('x', 245); sq.setAttribute('y', 183);
  sq.setAttribute('stroke', 'black');
  sq.setAttribute('fill', colors[scramble[131]]);
  svg.appendChild(sq);
  for (j = 0; j < 5; j ++) {
    x = 20*j+205;
    y = 143;
    var sq = document.createElementNS(svgNS,'rect');
      sq.setAttribute('width', 20); sq.setAttribute('height', 20);
      sq.setAttribute('x', x); sq.setAttribute('y', y);
      sq.setAttribute('stroke', 'black');
      sq.setAttribute('fill', colors[scramble[j+125]]);
      svg.appendChild(sq);
  }

  // B
  for (i = 0; i < 4; i ++) {
    for (j = 0; j < 4; j ++) {
      x = 308+20*(Math.floor(1.34*(j+1)-1));
      y = 103+20*(Math.floor(1.34*(i+1)-1));
      var sq = document.createElementNS(svgNS,'rect');
        sq.setAttribute('width', 20); sq.setAttribute('height', 20);
        sq.setAttribute('x', x); sq.setAttribute('y', y);
        sq.setAttribute('stroke', 'black');
        sq.setAttribute('fill', colors[scramble[i*4+j+64]]);
        svg.appendChild(sq);
    }
  }
  var sq = document.createElementNS(svgNS,'rect');
  sq.setAttribute('width', 20); sq.setAttribute('height', 20);
  sq.setAttribute('x', 348); sq.setAttribute('y', 103);
  sq.setAttribute('stroke', 'black');
  sq.setAttribute('fill', colors[scramble[132]]);
  svg.appendChild(sq);
  var sq = document.createElementNS(svgNS,'rect');
  sq.setAttribute('width', 20); sq.setAttribute('height', 20);
  sq.setAttribute('x', 348); sq.setAttribute('y', 123);
  sq.setAttribute('stroke', 'black');
  sq.setAttribute('fill', colors[scramble[133]]);
  svg.appendChild(sq);
  var sq = document.createElementNS(svgNS,'rect');
  sq.setAttribute('width', 20); sq.setAttribute('height', 20);
  sq.setAttribute('x', 348); sq.setAttribute('y', 163);
  sq.setAttribute('stroke', 'black');
  sq.setAttribute('fill', colors[scramble[139]]);
  svg.appendChild(sq);
  var sq = document.createElementNS(svgNS,'rect');
  sq.setAttribute('width', 20); sq.setAttribute('height', 20);
  sq.setAttribute('x', 348); sq.setAttribute('y', 183);
  sq.setAttribute('stroke', 'black');
  sq.setAttribute('fill', colors[scramble[140]]);
  svg.appendChild(sq);
  for (j = 0; j < 5; j ++) {
    x = 20*j+308;
    y = 143;
    var sq = document.createElementNS(svgNS,'rect');
      sq.setAttribute('width', 20); sq.setAttribute('height', 20);
      sq.setAttribute('x', x); sq.setAttribute('y', y);
      sq.setAttribute('stroke', 'black');
      sq.setAttribute('fill', colors[scramble[j+134]]);
      svg.appendChild(sq);
  }

  // D
  for (i = 0; i < 4; i ++) {
    for (j = 0; j < 4; j ++) {
      x = 103+20*(Math.floor(1.34*(j+1)-1));
      y = 205+20*(Math.floor(1.34*(i+1)-1));
      var sq = document.createElementNS(svgNS,'rect');
        sq.setAttribute('width', 20); sq.setAttribute('height', 20);
        sq.setAttribute('x', x); sq.setAttribute('y', y);
        sq.setAttribute('stroke', 'black');
        sq.setAttribute('fill', colors[scramble[i*4+j+80]]);
        svg.appendChild(sq);
    }
  }
  var sq = document.createElementNS(svgNS,'rect');
  sq.setAttribute('width', 20); sq.setAttribute('height', 20);
  sq.setAttribute('x', 143); sq.setAttribute('y', 205);
  sq.setAttribute('stroke', 'black');
  sq.setAttribute('fill', colors[scramble[141]]);
  svg.appendChild(sq);
  var sq = document.createElementNS(svgNS,'rect');
  sq.setAttribute('width', 20); sq.setAttribute('height', 20);
  sq.setAttribute('x', 143); sq.setAttribute('y', 225);
  sq.setAttribute('stroke', 'black');
  sq.setAttribute('fill', colors[scramble[142]]);
  svg.appendChild(sq);
  var sq = document.createElementNS(svgNS,'rect');
  sq.setAttribute('width', 20); sq.setAttribute('height', 20);
  sq.setAttribute('x', 143); sq.setAttribute('y', 265);
  sq.setAttribute('stroke', 'black');
  sq.setAttribute('fill', colors[scramble[148]]);
  svg.appendChild(sq);
  var sq = document.createElementNS(svgNS,'rect');
  sq.setAttribute('width', 20); sq.setAttribute('height', 20);
  sq.setAttribute('x', 143); sq.setAttribute('y', 285);
  sq.setAttribute('stroke', 'black');
  sq.setAttribute('fill', colors[scramble[149]]);
  svg.appendChild(sq);
  for (j = 0; j < 5; j ++) {
    x = 20*j+103;
    y = 245;
    var sq = document.createElementNS(svgNS,'rect');
      sq.setAttribute('width', 20); sq.setAttribute('height', 20);
      sq.setAttribute('x', x); sq.setAttribute('y', y);
      sq.setAttribute('stroke', 'black');
      sq.setAttribute('fill', colors[scramble[j+143]]);
      svg.appendChild(sq);
  }

  return svg;
}

function twoScrambleToSVG(scramble_string) {
  state = new Array(24).fill(0);
  state.fill(1, 4, 8); state.fill(2, 8, 12); state.fill(3, 12, 16);
  state.fill(4, 16, 20); state.fill(5, 20, 24);

  state_update = {
    "U": {
      0: 1, 1: 3, 2: 0, 3: 2,
      8: 16, 16: 20, 20: 4, 4: 8,
      9: 17, 17: 21, 21: 5, 5: 9,
    },
    "F": {
      8: 9, 9: 11, 11: 10, 10: 8,
      2: 4, 4: 13, 13: 19, 19: 2,
      3: 6, 6: 12, 12: 17, 17: 3,
    },
    "L": {
      16: 17, 17: 19, 19: 18, 18: 16,
      0: 8, 8: 12, 12: 23, 23: 0,
      2: 10, 10: 14, 14: 21, 21: 2,
    },
    "R": {
      4: 5, 5: 7, 7: 6, 6: 4,
      1: 22, 22: 13, 13: 9, 9: 1,
      3: 20, 20: 15, 15: 11, 11: 3,
    },
    "D": {
      12: 13, 13: 15, 15: 14, 14: 12,
      10: 6, 6: 22, 22: 18, 18: 10,
      11: 7, 7: 23, 23: 19, 19: 11,
    },
    "B": {
      20: 21, 21: 23, 23: 22, 22: 20,
      0: 18, 18: 15, 15: 5, 5: 0,
      1: 16, 16: 14, 14: 7, 7: 1,
    },
  }

  moves = scramble_string.split(" ");
  for (move of moves) {
    if (move.length > 1) {
      state = applyMove(state, state_update[move[0]]);
      state = applyMove(state, state_update[move[0]]);
      if (move[1] == "'") {
        state = applyMove(state, state_update[move[0]]);
      }
    } else {
      state = applyMove(state, state_update[move]);
    }
  }

  return state;
}

function pyraScrambleToSVG(scramble_string) {
  state = new Array(36).fill(0);
  state.fill(1, 5, 6); state.fill(1, 14, 17); state.fill(1, 21, 26);
  state.fill(2, 6, 11); state.fill(2, 17, 20); state.fill(2, 26, 27);
  state.fill(3, 27);

  state_update = {
    "U": {
      4: 6, 5: 4, 6: 5,
      15: 3, 3: 7, 7: 15,
      2: 17, 17: 14, 14: 2,
      13: 8, 8: 16, 16: 13,
    },
    "u": {4: 6, 5: 4, 6: 5,},
    "L": {
      20: 21, 21: 27, 27: 20,
      12: 22, 22: 28, 28: 12,
      11: 14, 14: 29, 29: 11,
      13: 23, 23: 32, 32: 13,
    },
    "l": {20: 21, 21: 27, 27: 20,},
    "R": {
      25: 26, 26: 31, 31: 25,
      24: 18, 18: 30, 30: 24,
      16: 19, 19: 29, 29: 16,
      23: 17, 17: 34, 34: 23,
    },
    "r": {25: 26, 26: 31, 31: 25,},
    "B": {
      0: 35, 35: 10, 10: 0,
      1: 33, 33: 9, 9: 1,
      2: 32, 32: 19, 19: 2,
      11: 34, 34: 8, 8: 11,
    },
    "b": {0: 35, 35: 10, 10: 0,},
  };

  moves = scramble_string.split(" ");
  for (move of moves) {
    if (move.length > 1) {
      state = applyMove(state, state_update[move[0]]);
      state = applyMove(state, state_update[move[0]]);
    } else {
      state = applyMove(state, state_update[move]);
    }
  }

  return state;
}



class FTO {
  /**
   * The this.state of the puzzle.
   * Interpretation:
   * Face Order (indexed starting at 0): U, L, F, R, BR, B, BL, D
   * Face Position: indexed 0-8 starting top left piece as if looking at face going left to right, top to bottom
   * Piece Number (or this.state[x]) = (Face Index * 9) + Face Position
   */
  state = new Array(72);


  /**
   * Creates the FTO
   */
  constructor() {

      //Creates a solved FTO.
      for (let i = 0; i < 72; i++) {
          this.state[i] = Math.floor(i / 9);
      }
  }

  getState() {
      return this.state;
  }

  /**
   * Applies a set of moves to the FTO
   *
   * @param scramble
   */
  doMoves(scramble) {
      let moves = scramble.split(" ");
      for (let i = 0; i < moves.length; i++) {
          switch (moves[i].trim()) {

              /**
               * R-based moves and rotations
               */
              case "R":
                  this.doR(1);
                  break;
              case "R'":
                  this.doR(2);
                  break;
              case "BLs'":
              case "Rs":
                  this.doRs(1);
                  break;
              case "BLs":
              case "Rs'":
                  this.doRs(2);
              case "Rw":
                  this.doR(1);
                  this.doRs(1);
                  break;
              case "Rw'":
                  this.doR(2);
                  this.doRs(2);
                  break;
              case "BLo'":
              case "Ro":
                  this.doR(1);
                  this.doRs(1);
                  this.doBL(2);
                  break;
              case "BLo":
              case "Ro'":
                  this.doR(2);
                  this.doRs(2);
                  this.doBL(1);
                  break;

              /**
               * U-based moves and rotations
               */
              case "U":
                  this.doU(1);
                  break;
              case "U'":
                  this.doU(2);
                  break;
              case "Ds'":
              case "E'":
              case "Us":
                  this.doUs(1);
                  break;
              case "Ds":
              case "E":
              case "Us'":
                  this.doUs(2);
                  break;
              case "Uw":
                  this.doU(1);
                  this.doUs(1);
                  break;
              case "Uw'":
                  this.doU(2);
                  this.doUs(2);
                  break;
              case "Do'":
              case "Uo":
                  this.doU(1);
                  this.doUs(1);
                  this.doD(2);
                  break;
              case "Do":
              case "Uo'":
                  this.doU(2);
                  this.doUs(2);
                  this.doD(1);
                  break;

              /**
               * L-based moves and rotations
               */
              case "L":
                  this.doL(1);
                  break;
              case "L'":
                  this.doL(2);
                  break;
              case "BRs'":
              case "Ls":
                  this.doLs(1);
                  break;
              case "BRs":
              case "Ls'":
                  this.doLs(2);
                  break;
              case "Lw":
                  this.doL(1);
                  this.doLs(1);
                  break;
              case "Lw'":
                  this.doL(1);
                  this.doLs(2);
                  break;
              case "BRo'":
              case "Lo":
                  this.doL(1);
                  this.doLs(1);
                  this.doBR(2);
                  break;
              case "BRo":
              case "Lo'":
                  this.doL(2);
                  this.doLs(2);
                  this.doBR(1);
                  break;

              /**
               * F-based moves and rotations
               */
              case "F":
                  this.doF(1);
                  break;
              case "F'":
                  this.doF(2);
                  break;
              case "Bs'":
              case "S":
              case "Fs":
                  this.doFs(1);
                  break;
              case "Bs":
              case "S'":
              case "Fs'":
                  this.doFs(2);
                  break;
              case "Fw":
                  this.doF(1);
                  this.doFs(1);
                  break;
              case "Fw'":
                  this.doF(1);
                  this.doFs(1);
                  break;
              case "Bo'":
              case "Fo":
                  this.doF(1);
                  this.doFs(1);
                  this.doB(2);
                  break;
              case "Bo":
              case "Fo'":
                  this.doF(2);
                  this.doFs(2);
                  this.doB(1);
                  break;

              /**
               * D-based moves and rotations
               */
              case "D":
                  this.doD(1);
                  break;
              case "D'":
                  this.doD(2);
                  break;
              case "Dw":
                  this.doD(1);
                  this.doUs(2);
                  break;
              case "Dw'":
                  this.doD(2);
                  this.doUs(1);
                  break;

              /**
               * B-based moves and rotations
               */
              case "B":
                  this.doB(1);
                  break;
              case "B'":
                  this.doB(2);
                  break;
              case "Bw":
                  this.doB(1);
                  this.doFs(2);
                  break;
              case "Bw'":
                  this.doB(2);
                  this.doFs(1);
                  break;

              /**
               * BR-based moves and rotations
               */
              case "BR":
                  this.doBR(1);
                  break;
              case "BR'":
                  this.doBR(2);
                  break;
              case "BRw":
                  this.doBR(1);
                  this.doLs(2);
                  break;
              case "BRw'":
                  this.doBR(2);
                  this.doLs(1);
                  break;

              /**
               * BL-based moves and rotations
               */
              case "BL":
                  this.doBL(1);
                  break;
              case "BL'":
                  this.doBL(2);
                  break;
              case "BLw":
                  this.doBL(1);
                  this.doRs(2);
                  break;
              case "BLw'":
                  this.doBL(2);
                  this.doRs(1);
                  break;

              default:
                  //throw new IllegalArgumentException("The move " + moves[i] + " is not supported.");
          }
      }
  }

  /**
   * Applies a R move "times" times
   *
   * @param times
   */
  doR(times) {
      let temp;
      for (let i = 0; i < times; i++) {

          //Top Corners
          temp = this.state[4];
          this.state[4] = this.state[18];
          this.state[18] = this.state[40];
          this.state[40] = temp;

          //Back Corners
          temp = this.state[45];
          this.state[45] = this.state[13];
          this.state[13] = this.state[67];
          this.state[67] = temp;

          //Right Corners
          temp = this.state[31];
          this.state[31] = this.state[27];
          this.state[27] = this.state[35];
          this.state[35] = temp;

          //Bottom Corners
          temp = this.state[36];
          this.state[36] = this.state[8];
          this.state[8] = this.state[26];
          this.state[26] = temp;

          //U Edges
          temp = this.state[7];
          this.state[7] = this.state[21];
          this.state[21] = this.state[37];
          this.state[37] = temp;

          //R Edges
          temp = this.state[29];
          this.state[29] = this.state[32];
          this.state[32] = this.state[34];
          this.state[34] = temp;

          //Back Triangles
          temp = this.state[3];
          this.state[3] = this.state[20];
          this.state[20] = this.state[41];
          this.state[41] = temp;

          //Front Triangles
          temp = this.state[6];
          this.state[6] = this.state[25];
          this.state[25] = this.state[38];
          this.state[38] = temp;

          //Right Triangles
          temp = this.state[30];
          this.state[30] = this.state[28];
          this.state[28] = this.state[33];
          this.state[33] = temp;
      }
  }

  /**
   * Applies an Rs move "times" times
   *
   * @param times
   */
  doRs( times) {
      let temp;
      for (let i = 0; i < times; i++) {
          //UB Edges
          temp = this.state[2];
          this.state[2] = this.state[19];
          this.state[19] = this.state[42];
          this.state[42] = temp;

          //BU Edges
          temp = this.state[47];
          this.state[47] = this.state[16];
          this.state[16] = this.state[70];
          this.state[70] = temp;

          //UL Edges
          temp = this.state[5];
          this.state[5] = this.state[24];
          this.state[24] = this.state[39];
          this.state[39] = temp;

          //LU Edges
          temp = this.state[11];
          this.state[11] = this.state[65];
          this.state[65] = this.state[50];
          this.state[50] = temp;

          //U Triangles
          temp = this.state[1];
          this.state[1] = this.state[23];
          this.state[23] = this.state[43];
          this.state[43] = temp;

          //L Triangles
          temp = this.state[12];
          this.state[12] = this.state[66];
          this.state[66] = this.state[46];
          this.state[46] = temp;
      }
  }

  /**
   * Applies a BL move "times" times
   *
   * @param times
   */
  doBL( times) {
      let temp;
      for (let i = 0; i < times; i++) {
          //Top Corners
          temp = this.state[0];
          this.state[0] = this.state[44];
          this.state[44] = this.state[22];
          this.state[22] = temp;

          //Back Corners
          temp = this.state[49];
          this.state[49] = this.state[71];
          this.state[71] = this.state[17];
          this.state[17] = temp;

          //Bottom Corners
          temp = this.state[54];
          this.state[54] = this.state[58];
          this.state[58] = this.state[62];
          this.state[62] = temp;

          //Front Corners
          temp = this.state[9];
          this.state[9] = this.state[53];
          this.state[53] = this.state[63];
          this.state[63] = temp;

          //Front Edges
          temp = this.state[14];
          this.state[14] = this.state[52];
          this.state[52] = this.state[68];
          this.state[68] = temp;

          //Left Edges
          temp = this.state[55];
          this.state[55] = this.state[60];
          this.state[60] = this.state[57];
          this.state[57] = temp;

          //Left Triangles
          temp = this.state[56];
          this.state[56] = this.state[59];
          this.state[59] = this.state[61];
          this.state[61] = temp;

          //Top Triangles
          temp = this.state[10];
          this.state[10] = this.state[51];
          this.state[51] = this.state[64];
          this.state[64] = temp;

          //Bottom Triangles
          temp = this.state[15];
          this.state[15] = this.state[48];
          this.state[48] = this.state[69];
          this.state[69] = temp;
      }
  }

  /**
   * Applies a U move "times" times
   *
   * @param times
   */
  doU( times) {
      let temp;
      for (let i = 0; i < times; i++) {
          //Top Corners
          temp = this.state[0];
          this.state[0] = this.state[8];
          this.state[8] = this.state[4];
          this.state[4] = temp;

          //Back Corners
          temp = this.state[49];
          this.state[49] = this.state[13];
          this.state[13] = this.state[31];
          this.state[31] = temp;

          //Bottom Corners
          temp = this.state[54];
          this.state[54] = this.state[18];
          this.state[18] = this.state[36];
          this.state[36] = temp;

          //Frontish Corners
          temp = this.state[9];
          this.state[9] = this.state[27];
          this.state[27] = this.state[45];
          this.state[45] = temp;

          //U Edges
          temp = this.state[2];
          this.state[2] = this.state[5];
          this.state[5] = this.state[7];
          this.state[7] = temp;

          //Outer Edges
          temp = this.state[47];
          this.state[47] = this.state[11];
          this.state[11] = this.state[29];
          this.state[29] = temp;

          //U Triangles
          temp = this.state[1];
          this.state[1] = this.state[6];
          this.state[6] = this.state[3];
          this.state[3] = temp;

          //Right Triangles
          temp = this.state[12];
          this.state[12] = this.state[30];
          this.state[30] = this.state[48];
          this.state[48] = temp;

          //Left Triangles
          temp = this.state[10];
          this.state[10] = this.state[28];
          this.state[28] = this.state[46];
          this.state[46] = temp;
      }
  }

  /**
   * Applies a Us move "times" times
   *
   * @param times
   */
  doUs( times) {
      let temp;
      for (let i = 0; i < times; i++) {
          //Front Triangles
          temp = this.state[20];
          this.state[20] = this.state[56];
          this.state[56] = this.state[38];
          this.state[38] = temp;

          //Left Triangles
          temp = this.state[15];
          this.state[15] = this.state[51];
          this.state[51] = this.state[33];
          this.state[33] = temp;

          //FR Edges
          temp = this.state[21];
          this.state[21] = this.state[57];
          this.state[57] = this.state[39];
          this.state[39] = temp;

          //RF Edges
          temp = this.state[41];
          this.state[41] = this.state[14];
          this.state[14] = this.state[50];
          this.state[50] = temp;

          //FL Edges
          temp = this.state[19];
          this.state[19] = this.state[55];
          this.state[55] = this.state[37];
          this.state[37] = temp;

          //LF Edges
          temp = this.state[16];
          this.state[16] = this.state[52];
          this.state[52] = this.state[43];
          this.state[43] = temp;
      }
  }

  /**
   * Applies a D move "times" times
   *
   * @param times
   */
  doD( times) {
      let temp;
      for (let i = 0; i < times; i++) {
          //Bottom Corners
          temp = this.state[63];
          this.state[63] = this.state[71];
          this.state[71] = this.state[67];
          this.state[67] = temp;

          //Up Corners
          temp = this.state[17];
          this.state[17] = this.state[53];
          this.state[53] = this.state[35];
          this.state[35] = temp;

          //Right Corners
          temp = this.state[22];
          this.state[22] = this.state[58];
          this.state[58] = this.state[40];
          this.state[40] = temp;

          //Left Corners
          temp = this.state[62];
          this.state[62] = this.state[44];
          this.state[44] = this.state[26];
          this.state[26] = temp;

          //Bottom Edges
          temp = this.state[65];
          this.state[65] = this.state[68];
          this.state[68] = this.state[70];
          this.state[70] = temp;

          //Outer Edges
          temp = this.state[24];
          this.state[24] = this.state[60];
          this.state[60] = this.state[42];
          this.state[42] = temp;

          //Bottom Triangles
          temp = this.state[64];
          this.state[64] = this.state[69];
          this.state[69] = this.state[66];
          this.state[66] = temp;

          //Right Triangles
          temp = this.state[25];
          this.state[25] = this.state[61];
          this.state[61] = this.state[43];
          this.state[43] = temp;

          //Left Triangles
          temp = this.state[23];
          this.state[23] = this.state[59];
          this.state[59] = this.state[41];
          this.state[41] = temp;
      }
  }

  /**
   * Applies an L move "times" times
   *
   * @param times
   */
  doL( times) {
      let temp;
      for (let i = 0; i < times; i++) {
          //U Corners
          temp = this.state[0];
          this.state[0] = this.state[62];
          this.state[62] = this.state[18];
          this.state[18] = temp;

          //Bottom Corners
          temp = this.state[54];
          this.state[54] = this.state[22];
          this.state[22] = this.state[8];
          this.state[8] = temp;

          //Back Corners
          temp = this.state[49];
          this.state[49] = this.state[63];
          this.state[63] = this.state[27];
          this.state[27] = temp;

          //Frontish Corners
          temp = this.state[9];
          this.state[9] = this.state[17];
          this.state[17] = this.state[13];
          this.state[13] = temp;

          //Left Edges
          temp = this.state[11];
          this.state[11] = this.state[14];
          this.state[14] = this.state[16];
          this.state[16] = temp;

          //Right Edges
          temp = this.state[5];
          this.state[5] = this.state[57];
          this.state[57] = this.state[19];
          this.state[19] = temp;

          //Left Triangles
          temp = this.state[10];
          this.state[10] = this.state[15];
          this.state[15] = this.state[12];
          this.state[12] = temp;

          //Top Back Left Triangles
          temp = this.state[1];
          this.state[1] = this.state[61];
          this.state[61] = this.state[20];
          this.state[20] = temp;

          //Top Front Triangles
          temp = this.state[6];
          this.state[6] = this.state[56];
          this.state[56] = this.state[23];
          this.state[23] = temp;
      }
  }

  /**
   * Applies an Ls move "times" times
   *
   * @param times
   */
  doLs( times) {
      let temp;
      for (let i = 0; i < times; i++) {
          //Top Triangles
          temp = this.state[3];
          this.state[3] = this.state[59];
          this.state[59] = this.state[25];
          this.state[25] = temp;

          //Right Triangles
          temp = this.state[28];
          this.state[28] = this.state[48];
          this.state[48] = this.state[64];
          this.state[64] = temp;

          //UB Edges
          temp = this.state[2];
          this.state[2] = this.state[60];
          this.state[60] = this.state[21];
          this.state[21] = temp;

          //BU Edges
          temp = this.state[47];
          this.state[47] = this.state[68];
          this.state[68] = this.state[32];
          this.state[32] = temp;

          //UR Edges
          temp = this.state[7];
          this.state[7] = this.state[55];
          this.state[55] = this.state[24];
          this.state[24] = temp;

          //RU Edges
          temp = this.state[29];
          this.state[20] = this.state[52];
          this.state[52] = this.state[65];
          this.state[65] = temp;
      }
  }

  /**
   * Applies BR "times" times
   *
   * @param times
   */
  doBR( times) {
      let temp;
      for (let i = 0; i < times; i++) {
          //Top Corners
          temp = this.state[4];
          this.state[4] = this.state[26];
          this.state[26] = this.state[58];
          this.state[58] = temp;

          //Bottom Corners
          temp = this.state[36];
          this.state[36] = this.state[40];
          this.state[40] = this.state[44];
          this.state[44] = temp;

          //Back Corners
          temp = this.state[45];
          this.state[45] = this.state[35];
          this.state[35] = this.state[71];
          this.state[71] = temp;

          //Rightish Corners
          temp = this.state[31];
          this.state[31] = this.state[67];
          this.state[67] = this.state[53];
          this.state[53] = temp;

          //Outer Edges
          temp = this.state[34];
          this.state[34] = this.state[70];
          this.state[70] = this.state[50];
          this.state[50] = temp;

          //Inner Edges
          temp = this.state[37];
          this.state[37] = this.state[42];
          this.state[42] = this.state[39];
          this.state[39] = temp;

          //Inner Triangles
          temp = this.state[38];
          this.state[38] = this.state[41];
          this.state[41] = this.state[43];
          this.state[43] = temp;

          //Top Outer Triangles
          temp = this.state[30];
          this.state[30] = this.state[66];
          this.state[66] = this.state[51];
          this.state[51] = temp;

          //Bottom Outer Triangles
          temp = this.state[33];
          this.state[33] = this.state[69];
          this.state[69] = this.state[46];
          this.state[46] = temp;
      }
  }

  /**
   * Applies F "times" times
   *
   * @param times
   */
  doF( times) {
      let temp;
      for (let i = 0; i < times; i++) {
          //Top Corners
          temp = this.state[8];
          this.state[8] = this.state[62];
          this.state[62] = this.state[40];
          this.state[40] = temp;

          //Bottom Corners
          temp = this.state[18];
          this.state[18] = this.state[22];
          this.state[22] = this.state[26];
          this.state[26] = temp;

          //Right Corners
          temp = this.state[27];
          this.state[27] = this.state[17];
          this.state[17] = this.state[67];
          this.state[67] = temp;

          //Left Corners
          temp = this.state[13];
          this.state[13] = this.state[63];
          this.state[63] = this.state[35];
          this.state[35] = temp;

          //Front Edges
          temp = this.state[19];
          this.state[19] = this.state[24];
          this.state[24] = this.state[21];
          this.state[21] = temp;

          //Outer Edges
          temp = this.state[16];
          this.state[16] = this.state[65];
          this.state[65] = this.state[32];
          this.state[32] = temp;

          //Front Triangles
          temp = this.state[20];
          this.state[20] = this.state[23];
          this.state[23] = this.state[25];
          this.state[25] = temp;

          //Outer Right Top Triangles
          temp = this.state[28];
          this.state[28] = this.state[15];
          this.state[15] = this.state[66];
          this.state[66] = temp;

          //Outer Left Top Triangles
          temp = this.state[12];
          this.state[12] = this.state[64];
          this.state[64] = this.state[33];
          this.state[33] = temp;
      }
  }

  /**
   * Applies an Fs move "times" times
   *
   * @param times
   */
  doFs( times) {
      let temp;
      for (let i = 0; i < times; i++) {
          //Top Triangles
          temp = this.state[6];
          this.state[6] = this.state[61];
          this.state[61] = this.state[41];
          this.state[41] = temp;

          //Left Triangles
          temp = this.state[10];
          this.state[10] = this.state[69];
          this.state[69] = this.state[30];
          this.state[30] = temp;

          //UR Edges
          temp = this.state[7];
          this.state[7] = this.state[57];
          this.state[57] = this.state[42];
          this.state[42] = temp;

          //RU Edges
          temp = this.state[29];
          this.state[29] = this.state[14];
          this.state[14] = this.state[70];
          this.state[70] = temp;

          //UL Edges
          temp = this.state[5];
          this.state[5] = this.state[60];
          this.state[60] = this.state[37];
          this.state[37] = temp;

          //LU Edges
          temp = this.state[11];
          this.state[11] = this.state[68];
          this.state[68] = this.state[34];
          this.state[34] = temp;
      }
  }

  /**
   * Applies a B move "times" times
   *
   * @param times
   */
  doB( times) {
      let temp;
      for (let i = 0; i < times; i++) {
          //UBL Corners
          temp = this.state[0];
          this.state[0] = this.state[36];
          this.state[36] = this.state[58];
          this.state[58] = temp;

          //Back Corners
          temp = this.state[49];
          this.state[49] = this.state[45];
          this.state[45] = this.state[53];
          this.state[53] = temp;

          //Left Bottom Corners
          temp = this.state[54];
          this.state[54] = this.state[4];
          this.state[4] = this.state[44];
          this.state[44] = temp;

          //LUB Corners
          temp = this.state[9];
          this.state[9] = this.state[31];
          this.state[31] = this.state[71];
          this.state[71] = temp;

          //Back Edges
          temp = this.state[47];
          this.state[47] = this.state[50];
          this.state[50] = this.state[52];
          this.state[52] = temp;

          //Outer Edges
          temp = this.state[2];
          this.state[2] = this.state[39];
          this.state[39] = this.state[55];
          this.state[55] = temp;

          //Back Triangles
          temp = this.state[46];
          this.state[46] = this.state[51];
          this.state[51] = this.state[48];
          this.state[48] = temp;

          //UBR Triangles
          temp = this.state[3];
          this.state[3] = this.state[43];
          this.state[43] = this.state[56];
          this.state[56] = temp;

          //UBL Triangles
          temp = this.state[1];
          this.state[1] = this.state[38];
          this.state[38] = this.state[59];
          this.state[59] = temp;
      }
  }
}

function ftoScrambleToSVG(scramble_string) {
  var fto = new FTO();
  fto.doMoves(scramble_string);
  return fto.getState();
}

function fto_image(state, colors){
  returnedString = "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n" +
          "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n" +
          "\t viewBox=\"0 0 98 98\" style=\"enable-background:new 0 0 98 98;\" xml:space=\"preserve\">\n" +
          "<style type=\"text/css\">\n" +
          "\t.st0{fill:#FFFFFF;stroke:#808080;stroke-width:5;}\n" +
          "\t.st1{fill:#FFFFFF;stroke:#808080;stroke-width:0.1;}\n" +
          "</style>\n" +
          "<polygon\n" +
          "\tid=\"outer_square1\"\n" +
          "\tpoints=\"19,9.6 19,45.1 54.5,45.1 54.5,9.6\"\n" +
          "\tstyle=\"fill:white;stroke:gray;stroke-width:2.5\"/>\n" +
          "<polygon\n" +
          "\tid=\"outer_square2\"\n" +
          "\tpoints=\"19,51.7 54.5,51.7 54.5,87.2 19,87.2\"\n" +
          "\tstyle=\"fill:white;stroke:gray;stroke-width:2.5\"/>\n" +
          "\n" +
          "<polygon id=\"0\" points=\"19,9.6 30.8,9.6 24.9,15.5\"\n" +
          "\tstyle=\"fill:" + colors[state[0]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"1\" points=\"30.8,9.6 24.9,15.5 36.8,15.5\"\n" +
          "\tstyle=\"fill:" + colors[state[1]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"2\" points=\"30.8,9.6 36.8,15.5 42.7,9.6 \"\n" +
          "\tstyle=\"fill:" + colors[state[2]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"3\" points=\"36.8,15.5 42.7,9.6 48.6,15.5\"\n" +
          "\tstyle=\"fill:" + colors[state[3]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"4\" points=\"42.7,9.6 48.6,15.5 54.5,9.6\"\n" +
          "\tstyle=\"fill:" + colors[state[4]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"5\" points=\"24.9,15.5 30.8,21.4 36.8,15.5\"\n" +
          "\tstyle=\"fill:" + colors[state[5]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"6\" points=\"30.8,21.4 36.8,15.5 42.7,21.4\"\n" +
          "\tstyle=\"fill:" + colors[state[6]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"7\" points=\"36.8,15.5 42.7,21.4 48.6,15.5\"\n" +
          "\tstyle=\"fill:" + colors[state[7]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"8\" points=\"30.8,21.4 36.8,27.3 42.7,21.4\"\n" +
          "\tstyle=\"fill:" + colors[state[8]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"9\" points=\"19,21.4 24.9,15.5 19,9.6\"\n" +
          "\tstyle=\"fill:" + colors[state[9]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"10\" points=\"24.9,27.3 19,21.4 24.9,15.5\"\n" +
          "\tstyle=\"fill:" + colors[state[10]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"11\" points=\"24.9,27.3 30.8,21.4 24.9,15.5\"\n" +
          "\tstyle=\"fill:" + colors[state[11]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"12\" points=\"30.8,33.3 24.9,27.3 30.8,21.4\"\n" +
          "\tstyle=\"fill:" + colors[state[12]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"13\" points=\"30.8,33.3 36.8,27.3 30.8,21.4\"\n" +
          "\tstyle=\"fill:" + colors[state[13]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"14\" points=\"19,33.3 24.9,27.3 19,21.4\"\n" +
          "\tstyle=\"fill:" + colors[state[14]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"15\" points=\"19,33.3 24.9,39.2 24.9,27.3\"\n" +
          "\tstyle=\"fill:" + colors[state[15]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"16\" points=\"24.9,39.2 30.8,33.3 24.9,27.3\"\n" +
          "\tstyle=\"fill:" + colors[state[16]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"17\" points=\"19,45.1 19,33.3 24.9,39.2\"\n" +
          "\tstyle=\"fill:" + colors[state[17]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"18\" points=\"42.7,33.3 36.8,27.3 30.8,33.3\"\n" +
          "\tstyle=\"fill:" + colors[state[18]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"19\" points=\"36.8,39.2 30.8,33.3 24.9,39.2\"\n" +
          "\tstyle=\"fill:" + colors[state[19]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"20\" points=\"42.7,33.3 36.8,39.2 30.8,33.3\"\n" +
          "\tstyle=\"fill:" + colors[state[20]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"21\" points=\"48.6,39.2 42.7,33.3 36.8,39.2\"\n" +
          "\tstyle=\"fill:" + colors[state[21]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"22\" points=\"30.8,45.1 24.9,39.2 19,45.1\"\n" +
          "\tstyle=\"fill:" + colors[state[22]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"23\" points=\"36.8,39.2 30.8,45.1 24.9,39.2\"\n" +
          "\tstyle=\"fill:" + colors[state[23]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"24\" points=\"42.7,45.1 36.8,39.2 30.8,45.1\"\n" +
          "\tstyle=\"fill:" + colors[state[24]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"25\" points=\"42.7,45.1 48.6,39.2 36.8,39.2\"\n" +
          "\tstyle=\"fill:" + colors[state[25]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"26\" points=\"54.5,45.1 42.7,45.1 48.6,39.2\"\n" +
          "\tstyle=\"fill:" + colors[state[26]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"27\" points=\"42.7,21.4 36.8,27.3 42.7,33.3\"\n" +
          "\tstyle=\"fill:" + colors[state[27]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"28\" points=\"42.7,21.4 48.6,27.3 42.7,33.3\"\n" +
          "\tstyle=\"fill:" + colors[state[28]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"29\" points=\"48.6,15.5 42.7,21.4 48.6,27.3\"\n" +
          "\tstyle=\"fill:" + colors[state[29]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"30\" points=\"54.5,21.4 48.6,15.5 48.6,27.3\"\n" +
          "\tstyle=\"fill:" + colors[state[30]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"31\" points=\"54.5,9.6 54.5,21.4 48.6,15.5\"\n" +
          "\tstyle=\"fill:" + colors[state[31]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"32\" points=\"48.6,27.3 42.7,33.3 48.6,39.2 \"\n" +
          "\tstyle=\"fill:" + colors[state[32]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"33\" points=\"48.6,27.3 54.5,33.3 48.6,39.2\"\n" +
          "\tstyle=\"fill:" + colors[state[33]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"34\" points=\"54.5,21.4 48.6,27.3 54.5,33.3\"\n" +
          "\tstyle=\"fill:" + colors[state[34]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"35\" points=\"54.5,33.3 48.6,39.2 54.5,45.1\"\n" +
          "\tstyle=\"fill:" + colors[state[35]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"36\" points=\"19,63.5 24.9,57.6 19,51.7\"\n" +
          "\tstyle=\"fill:" + colors[state[36]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"37\" points=\"19,75.4 24.9,69.4 19,63.5\"\n" +
          "\tstyle=\"fill:" + colors[state[37]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"38\" points=\"24.9,69.4 19,63.5 24.9,57.6\"\n" +
          "\tstyle=\"fill:" + colors[state[38]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"39\" points=\"24.9,69.4 30.8,63.5 24.9,57.6\"\n" +
          "\tstyle=\"fill:" + colors[state[39]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"40\" points=\"19,87.2 19,75.4 24.9,81.3\"\n" +
          "\tstyle=\"fill:" + colors[state[40]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"41\" points=\"19,75.4 24.9,81.3 24.9,69.4\"\n" +
          "\tstyle=\"fill:" + colors[state[41]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"42\" points=\"24.9,81.3 30.8,75.4 24.9,69.4\"\n" +
          "\tstyle=\"fill:" + colors[state[42]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"43\" points=\"30.8,75.4 24.9,69.4 30.8,63.5\"\n" +
          "\tstyle=\"fill:" + colors[state[43]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"44\" points=\"30.8,75.4 36.8,69.4 30.8,63.5\"\n" +
          "\tstyle=\"fill:" + colors[state[44]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"45\" points=\"19,51.7 30.8,51.7 24.9,57.6\"\n" +
          "\tstyle=\"fill:" + colors[state[45]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"46\" points=\"30.8,51.7 24.9,57.6 36.8,57.6\"\n" +
          "\tstyle=\"fill:" + colors[state[46]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"47\" points=\"30.8,51.7 36.8,57.6 42.7,51.7\"\n" +
          "\tstyle=\"fill:" + colors[state[47]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"48\" points=\"36.8,57.6 42.7,51.7 48.6,57.6\"\n" +
          "\tstyle=\"fill:" + colors[state[48]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"49\" points=\"42.7,51.7 48.6,57.6 54.5,51.7\"\n" +
          "\tstyle=\"fill:" + colors[state[49]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"50\" points=\"24.9,57.6 30.8,63.5 36.8,57.6\"\n" +
          "\tstyle=\"fill:" + colors[state[50]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"51\" points=\"30.8,63.5 36.8,57.6 42.7,63.5\"\n" +
          "\tstyle=\"fill:" + colors[state[51]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"52\" points=\"36.8,57.6 42.7,63.5 48.6,57.6\"\n" +
          "\tstyle=\"fill:" + colors[state[52]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"53\" points=\"30.8,63.5 36.8,69.4 42.7,63.5\"\n" +
          "\tstyle=\"fill:" + colors[state[53]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"54\" points=\"54.5,51.7 54.5,63.5 48.6,57.6\"\n" +
          "\tstyle=\"fill:" + colors[state[54]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"55\" points=\"48.6,57.6 42.7,63.5 48.6,69.4\"\n" +
          "\tstyle=\"fill:" + colors[state[55]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"56\" points=\"54.5,63.5 48.6,57.6 48.6,69.4\"\n" +
          "\tstyle=\"fill:" + colors[state[56]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"57\" points=\"54.5,63.5 48.6,69.4 54.5,75.4\"\n" +
          "\tstyle=\"fill:" + colors[state[57]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"58\" points=\"42.7,63.5 36.8,69.4 42.7,75.4\"\n" +
          "\tstyle=\"fill:" + colors[state[58]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"59\" points=\"42.7,63.5 48.6,69.4 42.7,75.4\"\n" +
          "\tstyle=\"fill:" + colors[state[59]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"60\" points=\"48.6,69.4 42.7,75.4 48.6,81.3\"\n" +
          "\tstyle=\"fill:" + colors[state[60]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"61\" points=\"48.6,69.4 54.5,75.4 48.6,81.3\"\n" +
          "\tstyle=\"fill:" + colors[state[61]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"62\" points=\"54.5,75.4 48.6,81.3 54.5,87.2\"\n" +
          "\tstyle=\"fill:" + colors[state[62]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"63\" points=\"54.5,87.2 42.7,87.2 48.6,81.3\"\n" +
          "\tstyle=\"fill:" + colors[state[63]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"64\" points=\"42.7,87.2 48.6,81.3 36.8,81.3\"\n" +
          "\tstyle=\"fill:" + colors[state[64]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"65\" points=\"42.7,87.2 36.8,81.3 30.8,87.2\"\n" +
          "\tstyle=\"fill:" + colors[state[65]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"66\" class=\"st1\" points=\"36.8,81.3 30.8,87.2 24.9,81.3\"\n" +
          "\tstyle=\"fill:" + colors[state[66]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"67\" class=\"st1\" points=\"30.8,87.2 24.9,81.3 19,87.2\"\n" +
          "\tstyle=\"fill:" + colors[state[67]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"68\" class=\"st1\" points=\"48.6,81.3 42.7,75.4 36.8,81.3\"\n" +
          "\tstyle=\"fill:" + colors[state[68]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"69\" points=\"42.7,75.4 36.8,81.3 30.8,75.4\"\n" +
          "\tstyle=\"fill:" + colors[state[69]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"70\" class=\"st1\" points=\"36.8,81.3 30.8,75.4 24.9,81.3\"\n" +
          "\tstyle=\"fill:" + colors[state[70]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "<polygon id=\"71\" class=\"st1\" points=\"42.7,75.4 36.8,69.4 30.8,75.4\"\n" +
          "\tstyle=\"fill:" + colors[state[71]] + ";stroke:gray;stroke-width:.1\"/>\n" +
          "\n" +
          "<polygon\n" +
          "\tid=\"u_face\"\n" +
          "\tpoints=\"19,9.6 54.5,9.6 36.8,27.3\"\n" +
          "\tstyle=\"fill:none;stroke:gray;stroke-width:1\"/>\n" +
          "<polygon\n" +
          "\tid=\"l_face\"\n" +
          "\tpoints=\"19,45.1 19,9.6 36.8,27.3\"\n" +
          "\tstyle=\"fill:none;stroke:gray;stroke-width:1\"/>\n" +
          "<polygon\n" +
          "\tid=\"r_face\"\n" +
          "\tpoints=\"54.5,9.6 54.5,45.1 36.8,27.3\"\n" +
          "\tstyle=\"fill:none;stroke:gray;stroke-width:1\"/>\n" +
          "<polygon\n" +
          "\tid=\"f_face\"\n" +
          "\tpoints=\"54.5,45.1 19,45.1 36.8,27.3\"\n" +
          "\tstyle=\"fill:none;stroke:gray;stroke-width:1\"/>\n" +
          "<polygon\n" +
          "\tid=\"b_face\"\n" +
          "\tpoints=\"19,51.7 54.5,51.7 36.8,69.4\"\n" +
          "\tstyle=\"fill:none;stroke:gray;stroke-width:1\"/>\n" +
          "<polygon\n" +
          "\tid=\"br_face\"\n" +
          "\tpoints=\"19,87.2 19,51.7 36.8,69.4\"\n" +
          "\tstyle=\"fill:none;stroke:gray;stroke-width:1\"/>\n" +
          "<polygon\n" +
          "\tid=\"bl_face\"\n" +
          "\tpoints=\"54.5,51.7 54.5,87.2 36.8,69.4\"\n" +
          "\tstyle=\"fill:none;stroke:gray;stroke-width:1\"/>\n" +
          "<polygon\n" +
          "\tid=\"d_face\"\n" +
          "\tpoints=\"54.5,87.2 19,87.2 36.8,69.4\"\n" +
          "\tstyle=\"fill:none;stroke:gray;stroke-width:1\"/>\n" +
          "</svg>\n";
  return returnedString;
}

module.exports = {twoScrambleToSVG, pyraScrambleToSVG, skewbScrambleToSVG, ftoScrambleToSVG, fourScrambleToSVG, fiveScrambleToSVG, skewb_image, fto_image, image_4x4, image_5x5}
